import React, { useState } from "react";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import css from "./StatisticMobileModal.module.css";
import { MobileFilter } from "../../../../../stories/MobileFilter/MobileFilter";
import { Button } from "../../../../../stories/Button/Button";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import {
  CancelIconBlack,
  BookmarkIconBlack,
  FilterIconBlack,
} from "../../../../../constant/imagePath";
import Colors from "../../../../../stories/assets/Colors";
import { ReactSVG } from "react-svg";
import ModalSkeletonCssClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import ReactApexChart from "react-apexcharts";

const StatisticMobileModal = ({
  show,
  setShow,
  location,
  setLocation,
  sport,
  setSport,
  season,
  setSeason,
}) => {
  const [filtervalue, setFiltervalue] = useState("Tennis");
  const [isFilter, setIsFilter] = useState(false);

  const mobileFilters = ["Tennis", "Baseball", "Skating", "Soccer"];
  const options = {
    chart: {
      height: 350,
      type: "area",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      type: "string",
      categories: [
        "<$.5k",
        "$0.5k+",
        "$1k+",
        "$1.5+",
        "$2k+",
        "$2.5k+",
        "$3k+",
        "$3.5k+",
        "$4k+",
        "$4.5k+",
        "$5k+",
        "$5.5k+",
        "$6k+",
      ],
    },
    yaxis: {
      labels: {
        formatter: (value) => {
          return `$${value}`;
        },
      },
      min: 0,
      max: 400,
      tickAmount: 4,
    },
    // tooltip: {
    //   x: {
    //     format: "dd/MM/yy HH:mm",
    //   },
    // },
  };
  const series = [
    {
      name: "Summer",
      data: [301, 390, 280, 310, 340, 109, 110, 320, 205, 320, 340, 222, 340],
      color: `${Colors.errorColor}`,
    },
    {
      name: "Winter",
      data: [110, 320, 245, 320, 304, 352, 241, 331, 140, 280, 251, 142, 109],
      color: `${Colors.mainBlue}`,
    },
  ];
  return (
    <>
      <style jsx>{`
        .${ModalSkeletonCssClasses.body} {
          padding: 0px;
        }
        .modal .modal-dialog {
          width: 100% !important;
          margin: 0px !important;
        }
        .modal .modal-dialog {
          max-width: 100% !important;
          height: 100%;
        }
        .modal-content {
          min-height: 100%;
        }
        .modal {
          border-radius: 0px !important;
          background: white;
        }
        .${css.apexarea} .apexcharts-toolbar {
          display: none !important;
        }
        .${css.apexarea} .apexcharts-legend-marker {
          border-radius: 0px !important;
          margin: 0px 6px;
        }
        .${css.apexarea} .apexcharts-legend-series {
          margin: 12px 24px !important;
        }
      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        width={"100%"}
      >
        <Row className="g-0">
          {!isFilter ? (
            <>
              <Col sm={12} md={12}>
                <div
                  style={{
                    borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  }}
                  className={[css.FilterHeader].join(" ")}
                >
                  <ReactSVG
                    src={CancelIconBlack}
                    onClick={() => setShow(false)}
                  />

                  <h6
                    style={{
                      ...Fonts.b3,
                      color: Colors.neutralShadesOfNero,
                    }}
                  >
                    Season statistic
                  </h6>
                  <div />
                </div>
              </Col>
              <Col sm={12} md={12} className={[css.middleSection].join(" ")}>
                <div className={[css.mb24].join(" ")}>
                  <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
                    The <span style={{ ...Fonts.h9 }}>number of coaches</span>{" "}
                    is shown on the left side of the chart, and the bottom line
                    shows the profit for the current season as an indicator of
                    demand. 6k+ includes coaches with income $6000 and more.
                  </p>
                </div>

                <div className={[css.filtersDiv].join(" ")}>
                  <Button
                    label=""
                    size="small"
                    icon={FilterIconBlack}
                    customStyle={{
                      backgroundColor: Colors.neutralShadesOfWhiteSmoke,
                      marginRight: "8px",
                      height: "36px",
                    }}
                    onClick={() => setIsFilter(true)}
                  />

                  <MobileFilter
                    filters={mobileFilters}
                    state={filtervalue}
                    setter={setFiltervalue}
                  />
                </div>

                <div className={[css.graphMainDiv].join(" ")}>
                  <div style={{ width: "1000px", marginTop: "12px" }}>
                    <ReactApexChart
                      options={options}
                      series={series}
                      type="area"
                      height={300}
                      className={[css.apexarea].join(" ")}
                    />
                  </div>
                </div>
              </Col>
            </>
          ) : (
            <Col sm={12}>
              <div
                style={{
                  borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                }}
                className={[css.FilterHeader].join(" ")}
              >
                <ReactSVG
                  src={CancelIconBlack}
                  onClick={() => setIsFilter(false)}
                />

                <h6
                  style={{
                    ...Fonts.b3,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Filters
                </h6>
                <ReactSVG
                  src={BookmarkIconBlack}
                  // onClick={() => setIsSavedFilter(true)}
                />
              </div>

              <div className={[css.filterMiddleSection].join(" ")}>
                <div className={[css.mb32].join(" ")}>
                  <DropDown
                    label={"Choose Sport"}
                    placeholder={"All"}
                    options={[
                      {
                        value: "All",
                        label: "All",
                      },
                      {
                        value: "Royal-Tennis-Court",
                        label: "Royal Tennis Court",
                      },
                      {
                        value: "Green-Tennis-Court",
                        label: "Green Tennis Court",
                      },
                    ]}
                    setter={setSport}
                    state={sport}
                  />
                </div>
                <div className={[css.mb32].join(" ")}>
                  <DropDown
                    label={"Choose location"}
                    placeholder={"All"}
                    options={[
                      {
                        value: "All",
                        label: "All",
                      },
                      {
                        value: "Royal-Tennis-Court",
                        label: "Royal Tennis Court",
                      },
                      {
                        value: "Green-Tennis-Court",
                        label: "Green Tennis Court",
                      },
                    ]}
                    setter={setLocation}
                    state={location}
                  />
                </div>
                <div className={[css.mb32].join(" ")}>
                  <DropDown
                    label={"Choose season"}
                    placeholder={"All"}
                    options={[
                      {
                        value: "All",
                        label: "All",
                      },
                      {
                        value: "Royal-Tennis-Court",
                        label: "Royal Tennis Court",
                      },
                      {
                        value: "Green-Tennis-Court",
                        label: "Green Tennis Court",
                      },
                    ]}
                    setter={setSeason}
                    state={season}
                  />
                </div>
              </div>

              <div
                style={{
                  borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                }}
                className={[css.footerBtnsDiv].join(" ")}
              >
                <LinkButtonWithIcon
                  text={"Clear All"}
                  textColor={Colors.neutralShadesOfNero}
                  customStyle={{
                    ...Fonts.b1Mobile,
                  }}
                />

                <Button
                  label={"Apply"}
                  customStyle={{
                    ...Fonts.b1Mobile,
                    padding: "12px 32px",
                    border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    width: "156px",
                  }}
                  primary={true}
                  size="Large"
                />
              </div>
            </Col>
          )}
        </Row>
      </ModalSkeleton>
    </>
  );
};
export default StatisticMobileModal;
